import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Box, TextField, IconButton, Tooltip, Typography, Alert, Stack, Link,
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';
import DownloadIcon from '@mui/icons-material/Download';
import { useSnackbar } from 'notistack';

// 발급 직후 단 한 번만 보여 주는 토큰. 여기서 닫으면 다시는 평문으로 못 본다(서버도 저장 안 함).
// 흐름: 등록 → 토큰 복사 → 설치 파일 받기 → 설치. 그래서 여기서 바로 설치 파일 다이얼로그를 열 수 있게 한다.
const EqpAgentTokenDialog = ({ open, token, agentNm, onClose, onOpenInstaller }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(token);
      } else {
        const ta = document.createElement('textarea');
        ta.value = token;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        const ok = document.execCommand('copy');
        document.body.removeChild(ta);
        if (!ok) throw new Error('copy failed');
      }
      setCopied(true);
      enqueueSnackbar('토큰을 복사했습니다.', { variant: 'success' });
      setTimeout(() => setCopied(false), 1800);
    } catch {
      enqueueSnackbar('복사하지 못했습니다. 직접 선택해 주세요.', { variant: 'warning' });
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{agentNm} - 에이전트 토큰</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ pt: 1 }}>
          <Alert severity="warning">
            이 토큰은 지금 한 번만 보입니다. 에이전트 설치 시 설정 파일에 넣으세요.
          </Alert>

          <TextField
            fullWidth
            value={token || ''}
            InputProps={{
              readOnly: true,
              sx: { fontFamily: 'monospace', fontSize: 13 },
              endAdornment: (
                <Tooltip title={copied ? '복사했습니다' : '토큰 복사'}>
                  <IconButton onClick={copy} edge="end">
                    {copied ? <CheckIcon color="success" /> : <ContentCopyIcon />}
                  </IconButton>
                </Tooltip>
              ),
            }}
          />

          <Box>
            <Typography variant="subtitle2" gutterBottom>설치 순서</Typography>
            <Typography variant="body2" color="text.secondary">
              1. 에이전트 설치 파일 실행<br />
              2. KMES 주소 https://kmes.ksolution.store 와 토큰 입력<br />
              3. 장비관리에서 이 에이전트를 담당으로 지정
            </Typography>
          </Box>

          {onOpenInstaller && (
            <Box>
              <Link
                component="button"
                type="button"
                variant="body2"
                onClick={onOpenInstaller}
                sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}
              >
                <DownloadIcon fontSize="inherit" /> 설치 파일 받기
              </Link>
            </Box>
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={onClose}>확인</Button>
      </DialogActions>
    </Dialog>
  );
};

export default EqpAgentTokenDialog;
